import React from 'react';
import { hot } from 'react-hot-loader';

export default hot(module)(function (props) {
	return (
		<>
			<h4 className="text-center main-top-heading">{props.text}</h4>
			{props.children}
		</>
	);
});
